import { render, staticRenderFns } from "./LocationRow.vue?vue&type=template&id=95f826e6&scoped=true&"
import script from "./LocationRow.vue?vue&type=script&lang=js&"
export * from "./LocationRow.vue?vue&type=script&lang=js&"
import style0 from "./LocationRow.vue?vue&type=style&index=0&id=95f826e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f826e6",
  null
  
)

export default component.exports